{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ArrowSingleLeftIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowSingleLeftIcon = React.forwardRef<SVGSVGElement, ArrowSingleLeftIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 60 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M10.7064 48.1102C17.149 53.632 23.1985 59.3212 29.7705 64.3264C38.6199 71.0663 47.8545 77.3022 56.9606 83.7028C59.4671 85.465 60.3893 87.9492 59.0937 90.1007C57.7619 92.3106 54.8812 92.8397 52.5066 91.0623C40.8894 82.3658 29.2283 73.7159 17.7673 64.8127C12.7745 60.9344 8.23591 56.4772 3.4663 52.3075C-0.143558 49.1571 -0.122472 46.0926 3.55171 43.0531C16.0899 32.683 28.6195 22.303 41.1402 11.9132C45.2489 8.48711 49.1474 4.8116 53.2534 1.37829C54.2138 0.544365 55.4274 0.0587681 56.6979 0C58.5672 0.0656338 59.2918 2.26633 58.0047 4.03385C56.7172 5.79958 55.2582 7.4337 53.6492 8.9124C40.2941 21.1724 26.9112 33.4021 13.5004 45.6017C12.703 46.3309 11.8937 47.0457 10.7064 48.1102Z" fill={color}/>

      </svg>
    )
  }
)

ArrowSingleLeftIcon.displayName = 'ArrowSingleLeftIcon'
